import { Injectable } from '@angular/core';
import { LoggerService } from '@wz-services';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { AppInsightsService } from '../../../libs/modules/app-insights/app-insights.service';
import { AuthProjector } from '../../../libs/modules/tunnelsante/projectors/auth-projector';
import { AuthenticationApiService } from '../../../libs/modules/tunnelsante/services/api/authentication-api.service';
import { AuthenticationServiceBase } from '../../../libs/modules/tunnelsante/services/authentication-service-base';
import { LocalStorageService } from '../../../libs/modules/tunnelsante/services/storage/local-storage.service';
import { AuthenticationApiModels } from '../../../models/api/authentication-api.models';
import { AuthenticationModels } from '../../../models/authentication.models';
import { CommonModels } from '../../../models/common.models';
import { RegisterFormModels } from '../../../models/register-form.models';

@Injectable({
  providedIn: 'root',
})
export class AfiAuthenticationService extends AuthenticationServiceBase<
  AuthenticationModels.Broker,
  AuthenticationApiModels.BrokerInfoResponse
> {
  protected accountKind = CommonModels.AccountKind.Broker;

  constructor(
    authApiService: AuthenticationApiService,
    storageService: LocalStorageService,
    appInsightsService: AppInsightsService,
    loggerService: LoggerService,
  ) {
    super(authApiService, storageService, appInsightsService, loggerService);
  }

  /** Register */
  registerBroker(
    registrationForm: RegisterFormModels.BrokerRegisterForm,
  ): Observable<void> {
    return this.authApiService
      .registerBroker(AuthProjector.projectRegisterRequest(registrationForm))
      .pipe(
        map((apiAcc: AuthenticationApiModels.TokensResponse) => {
          this.setAccessToken(apiAcc.accessToken!);
          this.setRefreshToken(apiAcc.refreshToken!);
          return;
        }),
      );
  }

  //TODO How to force userId, brokerId
  forceGetAccessToken(): Observable<AuthenticationApiModels.TokensResponse> {
    return this.authApiService.loginTunnel(1103);
  }

  protected accountProjector(
    apiModel: AuthenticationApiModels.BrokerInfoResponse,
  ): AuthenticationModels.Broker {
    return Object.assign(new AuthenticationModels.Broker(), apiModel);
  }
}
